import Vue from 'vue'

/**
 * Capitalize strings
 *
 * @param str
 * @returns {*}
 */
const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)
Vue.filter('capitalize', capitalize)
